"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextInputPropTypes = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cnbuilder = require("cnbuilder");
var _reactInputMask = _interopRequireDefault(require("react-input-mask"));
var _uuid = require("uuid");
var _reactI18next = require("react-i18next");
var _closeCircleDefault = _interopRequireDefault(require("@teladoc/pulse/icons/close-circle-default.svg"));
var _lockDefault = _interopRequireDefault(require("@teladoc/pulse/icons/lock-default.svg"));
var _environment = _interopRequireDefault(require("@livongo/utilities/system/environment"));
var _useValidation = _interopRequireDefault(require("../Form/use-validation"));
var _useLabelValidation = _interopRequireDefault(require("../Form/use-label-validation"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _TextInputModule = _interopRequireDefault(require("./TextInput.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["classNameRoot", "classNameControl", "classNameItemContainer", "classNameItem", "classNameIcon", "testAttrRoot", "testAttrControl", "testAttrItem", "testAttrClear", "testAttrError", "testAttrWarning", "i18nItemLabel", "i18nClearLabel", "name", "id", "type", "label", "placeholder", "pattern", "required", "loading", "focus", "disabled", "error", "warningElement", "customValidationError", "defaultValue", "value", "icon", "iconPosition", "helpNode", "readOnly", "maxLength", "min", "max", "mask", "maskChar", "contentBefore", "contentAfter", "onChange", "onFocus", "onBlur", "onInvalid", "shouldRenderError", "shouldRenderHelpNode", "rootAttrs", "controlAttrs", "unitsBefore", "unitsAfter", "unitsFullText"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const TextInput = _ref => {
  let {
      classNameRoot,
      classNameControl,
      classNameItemContainer,
      classNameItem,
      classNameIcon,
      testAttrRoot,
      testAttrControl,
      testAttrItem,
      testAttrClear,
      testAttrError,
      testAttrWarning,
      i18nItemLabel,
      i18nClearLabel,
      name,
      id,
      type,
      label,
      placeholder,
      pattern,
      required,
      loading,
      focus,
      disabled,
      error,
      warningElement,
      customValidationError,
      defaultValue = '',
      value,
      icon,
      iconPosition,
      helpNode,
      readOnly,
      maxLength,
      min,
      max,
      mask,
      maskChar,
      contentBefore,
      contentAfter,
      onChange,
      onFocus,
      onBlur,
      onInvalid,
      shouldRenderError,
      shouldRenderHelpNode,
      rootAttrs,
      controlAttrs,
      unitsBefore,
      unitsAfter,
      unitsFullText
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const [key, setKey] = (0, _react.useState)((0, _uuid.v4)());
  const [internalValue, setInternalValue] = (0, _react.useState)(value !== null && value !== void 0 ? value : '');
  const [showClear, setShowClear] = (0, _react.useState)(type === 'search' && (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.length));
  const {
    ref,
    errorId,
    isValid,
    errorElement,
    showInvalid,
    setValidationState
  } = (0, _useValidation.default)({
    id,
    disabled,
    error,
    customValidationError,
    onInvalid
  });
  const [showWarning, setShowWarning] = (0, _react.useState)(warningElement && required);
  const isWindows = _environment.default.isWindows();
  const onChangeCallback = evt => {
    setInternalValue(evt.target.value);
    if (evt.type === 'change') {
      setValidationState(null);
      setShowWarning(false);
      if (evt.target.value.length === 0 && required) {
        setShowWarning(true);
      }
    }
    if (type === 'search') {
      setShowClear(evt.target.value.length > 0);
    }
    if (onChange) {
      onChange(evt);
    }
  };
  const onInvalidCallback = evt => {
    evt.preventDefault();
  };
  const onClear = () => {
    setInternalValue('');
    setKey((0, _uuid.v4)());
    setShowClear(false);
    setTimeout(() => {
      ref.current.getInputDOMNode().focus();
    }, 0);
  };
  const describedBy = [];
  if (helpNode) {
    describedBy.push("".concat(id, "-help"));
  }

  // AdvancedSelect uses TextInput, but renders it's own error message
  // if the form is NOT valid, and should render error is false
  // that means the parent component is rendering the error
  // but we still want the described by to occur
  if (showInvalid || !isValid && !shouldRenderError) {
    describedBy.push(errorId);
  }
  (0, _useLabelValidation.default)(label, i18nItemLabel, rest);
  (0, _react.useEffect)(() => {
    if (focus) {
      const {
        current: field
      } = ref;
      const fieldLength = field.value.length;
      field.focus();
      field.setSelectionRange(fieldLength, fieldLength);
    }
  }, [focus, ref]);
  (0, _react.useEffect)(() => {
    setValidationState(null);
  }, [disabled, setValidationState]);
  (0, _react.useEffect)(() => {
    if (!isValid) {
      setShowWarning(false);
    }
  }, [isValid]);
  (0, _react.useEffect)(() => {
    setInternalValue(value);
  }, [value]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread(_objectSpread({
    className: (0, _cnbuilder.cnb)(_TextInputModule.default.root, {
      [_TextInputModule.default.isSearch]: type === 'search'
    }, {
      [_TextInputModule.default.isLoading]: loading && !readOnly
    }, {
      [_TextInputModule.default.readOnly]: readOnly
    }, {
      [_TextInputModule.default.withHelpNode]: Boolean(helpNode)
    }, {
      [_TextInputModule.default.containsError]: !isValid
    }, {
      [_TextInputModule.default.containsWarning]: showWarning
    }, {
      [_TextInputModule.default["".concat(iconPosition, "Icon")]]: !readOnly && Boolean(icon)
    }, {
      [_TextInputModule.default.rightIcon]: readOnly
    }, {
      [_TextInputModule.default.disabled]: disabled
    }, classNameRoot)
  }, !isValid && {
    'data-invalid-field': true
  }), {}, {
    "data-test": testAttrRoot
  }, rootAttrs), {}, {
    children: [label && /*#__PURE__*/(0, _react.cloneElement)(label, {
      className: (0, _cnbuilder.cnb)(_TextInputModule.default.label, label.props.className),
      htmlFor: id,
      required
    }), helpNode && shouldRenderHelpNode && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _TextInputModule.default.helpNode,
      id: "".concat(id, "-help"),
      children: helpNode
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
      className: (0, _cnbuilder.cnb)(_TextInputModule.default.control, {
        [_TextInputModule.default.withAdditionalContent]: Boolean(contentBefore || contentAfter)
      }, classNameControl),
      "data-test": testAttrControl
    }, controlAttrs), {}, {
      children: [contentBefore && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _TextInputModule.default.contentBefore,
        children: contentBefore
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _cnbuilder.cnb)(_TextInputModule.default.itemContainer, {
          [_TextInputModule.default['with-units']]: Boolean(unitsBefore || unitsAfter),
          [_TextInputModule.default.disabled]: disabled,
          [_TextInputModule.default.readOnly]: readOnly
        }, classNameItemContainer),
        "aria-live": "polite",
        "aria-atomic": true,
        children: [unitsBefore && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _TextInputModule.default['units-before'],
          "aria-hidden": true,
          children: unitsBefore
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactInputMask.default, _objectSpread(_objectSpread(_objectSpread({
          ref: ref,
          id: id,
          "data-test": testAttrItem,
          className: (0, _cnbuilder.cnb)(_TextInputModule.default.item, classNameItem),
          name: name,
          type: type,
          placeholder: placeholder,
          disabled: disabled,
          "aria-label": i18nItemLabel,
          required: required,
          pattern: pattern,
          maxLength: maxLength,
          min: min,
          max: max,
          mask: mask,
          maskChar: maskChar,
          alwaysShowMask: false,
          readOnly: readOnly,
          "aria-disabled": readOnly,
          value: internalValue || internalValue === '' ? internalValue : defaultValue
        }, describedBy.length && {
          'aria-describedby': describedBy.join(' ')
        }), !isWindows && showInvalid && {
          'aria-errormessage': "".concat(errorId)
        }), {}, {
          "aria-invalid": !isValid,
          onChange: onChangeCallback,
          onFocus: onFocus,
          onBlur: onBlur,
          onInvalid: onInvalidCallback
        }, rest), key), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _TextInputModule.default['sr-only'],
          children: unitsFullText
        }), unitsAfter && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _TextInputModule.default['units-after'],
          "aria-hidden": true,
          children: unitsAfter
        }), readOnly && !disabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: (0, _cnbuilder.cnb)(_TextInputModule.default.icon, classNameIcon),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_lockDefault.default, {})
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [showClear && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
            testAttr: testAttrClear,
            className: _TextInputModule.default.clear,
            i18nLabel: i18nClearLabel || t('ui:textInput.clear'),
            disabled: disabled,
            onClick: onClear,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_closeCircleDefault.default, {})
          }), icon && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: (0, _cnbuilder.cnb)(_TextInputModule.default.icon, classNameIcon),
            children: icon
          }), loading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
            className: _TextInputModule.default.loader,
            testAttr: "loader",
            inline: true,
            size: "small"
          })]
        })]
      }), contentAfter && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _TextInputModule.default.contentAfter,
        children: contentAfter
      })]
    })), showWarning && warningElement && /*#__PURE__*/(0, _react.cloneElement)(warningElement, {
      id: "".concat(id, "-warning"),
      testAttr: testAttrWarning
    }), showInvalid && /*#__PURE__*/(0, _react.cloneElement)(errorElement, {
      id: errorId,
      testAttr: testAttrError
    })]
  }));
};
const TextInputPropTypes = exports.TextInputPropTypes = {
  /** Additional class(es) to add to the root element. */
  classNameRoot: _propTypes.default.string,
  /** Additional class(es) to add to the control element. */
  classNameControl: _propTypes.default.string,
  /** Additional class(es) to add to the input element's container. */
  classNameItemContainer: _propTypes.default.string,
  /** Additional class(es) to add to the input element. */
  classNameItem: _propTypes.default.string,
  /** Additional class(es) to add to the icon element. */
  classNameIcon: _propTypes.default.string,
  /** The name of the test attribute to associate to the component's root element. */
  testAttrRoot: _propTypes.default.string,
  /** The name of the test attribute to associate to the component's control element. */
  testAttrControl: _propTypes.default.string,
  /** The name of the test attribute to associate to the component's input item element. */
  testAttrItem: _propTypes.default.string,
  /** The name of the test attribute to associate to the component's clear button. */
  testAttrClear: _propTypes.default.string,
  /** The name of the test attribute to associate to the component's error element. */
  testAttrError: _propTypes.default.string,
  /** The name of the test attribute to associate to the component's warning element. */
  testAttrWarning: _propTypes.default.string,
  /** The aria-label to apply to the input item. */
  i18nItemLabel: _propTypes.default.string,
  /** The aria-label to apply to the clear button when `type="search"`. */
  i18nClearLabel: _propTypes.default.string,
  /** A unique name which is used to identify this element. If belonging to a form this is used as the key for serialization and is required. */
  name: _propTypes.default.string,
  /** A unique ID which is used to identify this element for accessibility purposes. */
  id: _propTypes.default.string.isRequired,
  /** What HTML input type the underlying input should be set to. */
  type: _propTypes.default.oneOf(['text', 'password', 'date', 'email', 'time', 'tel', 'search', 'number', 'hidden']),
  /** Text to display in the field before a user starts to type in the input. */
  placeholder: _propTypes.default.string,
  /** A custom label (typically a Label component) to display above the input. */
  label: _propTypes.default.element,
  /** A regular expression that the input value is checked against for validation. */
  pattern: _propTypes.default.string,
  /** Whether this field is required during validation. */
  required: _propTypes.default.bool,
  /** Whether to add a loading indicator in the input. */
  loading: _propTypes.default.bool,
  /** Disallows user interaction. */
  disabled: _propTypes.default.bool,
  /** Whether the field should be focused. */
  focus: _propTypes.default.bool,
  /** A validation error (typically a FormElementError component) to display when this component is part of a form and is invalid. */
  error: _propTypes.default.element,
  /** A warning message (typically a FormElementError component) to display when this component is part of a form, is required, and is empty. */
  warningElement: _propTypes.default.element,
  /** A custom validation error (typically a FormElementError component) to display and override any other possible error passed when this component is part of a form and is invalid. */
  customValidationError: _propTypes.default.element,
  /** Determines whether to render the error message if the input is invalid. If this is set to false the id prop must be passed in or aria-describedby association will not work. */
  shouldRenderError: _propTypes.default.bool,
  /** Determines whether to render the help node. If this is set to false the id prop must be passed in or aria-describedby association will not work. */
  shouldRenderHelpNode: _propTypes.default.bool,
  /** The default value to display in the input when mounted. */
  defaultValue: _propTypes.default.string,
  /** The value to display in the input element. */
  value: _propTypes.default.string,
  /** A custom icon (typically one of the Icon components) to show in the input field. */
  icon: _propTypes.default.element,
  /** If an icon is provided, whether it should appear on the left or right side of the input field. */
  iconPosition: _propTypes.default.oneOf(['left', 'right']),
  /** A custom help element to place above the input. */
  helpNode: _propTypes.default.node,
  /** Specifies that the input field is read-only. */
  readOnly: _propTypes.default.bool,
  /** Specifies the maximum number of characters allowed. */
  maxLength: _propTypes.default.number,
  /** Specifies the minimum value when type is `date` or `number`. */
  min: _propTypes.default.number,
  /** Specifies the maximum value when type is `date` or `number`. */
  max: _propTypes.default.number,
  /** A string to use as a mask. See <a href="https://github.com/sanniassin/react-input-mask#mask--string" target="_blank">react-input-mask</a>. */
  mask: _propTypes.default.string,
  /** Character to cover unfilled editable parts of mask. See <a href="https://github.com/sanniassin/react-input-mask#maskchar--string" target="_blank">react-input-mask</a>. */
  maskChar: _propTypes.default.string,
  /** An element to add inline before the input. */
  contentBefore: _propTypes.default.node,
  /** An element to add inline after the input. */
  contentAfter: _propTypes.default.node,
  /** Any additional properties to spread on to the root element. */
  rootAttrs: _propTypes.default.object,
  /** Any additional properties to spread on to the control element. */
  controlAttrs: _propTypes.default.object,
  /** Units to display before the input (ex: '$'). */
  unitsBefore: _propTypes.default.string,
  /** Units to display after the input (ex: 'lbs'). */
  unitsAfter: _propTypes.default.string,
  /** Units full text (ex: 'dollars' or 'pounds') for screen reader only (not for display). */
  unitsFullText: _propTypes.default.string,
  /**
   * Function to execute when the input changes.
   *
   * @param {SyntheticEvent} evt - The React `SyntheticEvent`.
   */
  onChange: _propTypes.default.func,
  /**
   * Function to execute when the input is focused.
   *
   * @param {SyntheticEvent} evt - The React `SyntheticEvent`.
   */
  onFocus: _propTypes.default.func,
  /**
   * Function to execute when the input loses focused.
   *
   * @param {SyntheticEvent} evt - The React `SyntheticEvent`.
   */
  onBlur: _propTypes.default.func,
  /**
   * Function to execute when the element is marked as invalid by a validation check.
   *
   * @param {ValidityState} validationState - ValidityState object for more fine grained control over error handling in a parent component if desired.
   */
  onInvalid: _propTypes.default.func
};
TextInput.defaultProps = {
  testAttrRoot: 'text-input-root',
  testAttrControl: 'text-input-control',
  testAttrItem: 'text-input-item',
  testAttrClear: 'text-input-clear',
  testAttrError: 'text-input-error',
  testAttrWarning: 'text-input-warning',
  type: 'text',
  maskChar: null,
  iconPosition: 'left',
  shouldRenderError: true,
  shouldRenderHelpNode: true
};
var _default = exports.default = TextInput;